import styled from "styled-components";
import newsfeed_orange from "../../../images/newsfeed_orange.svg";
import Give from "../../../images/gift_icon_orange.svg";
import getHelpIcon from "../../../images/get_help_header.svg";
import WhiteConnectIcon from "../../../images/connection-orange.svg";
import StationsModalBg from "../../../images/StationsModalBg.png";
import BackbuttonIcon from "../../../images/Backbutton.svg";
import GiftIcon from "../../../images/GiftIcon.png";
import GiftIconOrange from "../../../images/gift_icon_orange.svg";
import OrangeHomeIcon from "../../../images/home_icon_orange.svg";
import WVLogoGlobe from "../../../images/map_globe_icon.svg";

export const HeaderLayout = styled.header`
width:100%;
height:117px;
top:0;
display:flex;
position: absolute;
position: -webkit-fixed; /* Safari */
z-index:9;
padding:15px 25px;
background-image: linear-gradient(180deg, rgba(20, 30, 77, 0.6) 44.93%, rgba(23, 35, 96, 0.5125) 62.79%, rgba(30, 46, 115, 0) 93.23%);


& img.logo-image{
    max-width:200px;
    max-height:50px;    
    @media screen and (max-width: 480px){
         max-width:125px;
         max-height:50px; 
    } 

    @media screen and (max-width: 850px){
        max-width:160px;
        max-height:50px; 
    } 
}

@media screen and (max-width: 750px){
    z-index: 11;
    height: 70px;
    background-image: linear-gradient(180deg, rgba(33, 45, 104, 1) 60%, rgba(30, 46, 115, 1), rgba(30, 46, 115, 0.49), rgba(30, 46, 115, 0));
}
@media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
  and (orientation: portrait){ 
    height: 10%;
    background-image: linear-gradient(rgb(33, 45, 104) 60%, rgb(30, 46, 115), rgba(30, 46, 115, 0.49), rgba(30, 46, 115, 0));
  
  }
  @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
  and (orientation: landscape){ 
    height: 10%;
    background-image: linear-gradient(rgb(33, 45, 104) 60%, rgb(30, 46, 115), rgba(30, 46, 115, 0.49), rgba(30, 46, 115, 0));
  }
`

export const CommunityHeaderLayout = styled.header`
    position: absolute;
    width: 100%;
    height: 77px;
    left: 0px;
    top: 0%;
    z-index:10;
    opacity: ${props=> !props.isDay? 0.66 : ""};
    background: #FFF;
    filter: ${props=> !props.isDay? "drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.3))":""};
    &:after{
        content: "";
        position: absolute;
        width: 100%;
        height: 77px;
        top: 0;
        left:0;
        background: #FFF;
        opacity: 0.6;
        filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.3));
    }
    @media screen and (max-width: 850px){
        max-height: 58px;
        &:after{
            max-height: 58px;
        }
    }
`;

export const HeaderContent = styled.div`
    flex-grow:1;
    display: flex;
    align-items: baseline;
    ${props => props.logo && `
       width: 19%;
       @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
        and (orientation: landscape) { 
        & {
            width: 18%;
        }
    `}
    ${props => props.disclaimer && `
       width: 40%;
       justify-content: center;
       color: white;
       margin-top: 5px;
       margin-right:20px;
       @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
        and (orientation: portrait){ 
        & {
            width: 40%;
            top: 90vh;
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            text-align: center;
        }
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
        and (orientation: landscape){ 
        & {
            width: 30%;
            margin-top: 0px;
            margin-right: 2rem;
        }
    }
    `}
    ${props => props.search && `
       width: 8%;
       margin-right: -10%;
       @media screen and (max-width: 750px){
        width: 100%;
        }
        @media screen and (min-width: 1200px) and (max-width:1400px) {
            width: 12%;
            margin-right: -9%;
        }
    `}

    ${props => props.left && `
    justify-content: start;
    `}
    ${props => props.right && `
    justify-content: end;
    `}
    
`

export const HeaderNavLinks = styled.a`
    font-family: 'Lato-Bold';
    position: relative;
    cursor: pointer;
    color:${props => (props.textcolor) ? "#ffffff" : "#111111"};
    font-size: 17px;
    margin-top: 20px;
    margin-right: 15px;
    text-decoration:none;
    padding-left:20px;

    :before{
        content:"";
        position:absolute;
        top:4px;
        left:0;
        width:20px;
        height:20px;
        background-size:contain;
        background-repeat:no-repeat;
     }        
`
export const HeaderNavLinksMbl = styled.a`
    font-family: 'Lato-Bold';
    position: relative;
    cursor: pointer;
    color:${props => (props.textcolor) ? "#ffffff" : "#111111"};
    font-size: 17px;
    text-decoration:none;     
`

export const Communitylogo= styled.div`
     display:flex;
`

export const HeaderImage=styled.img`
    cursor: pointer;
    width: 40px;
    object-fit: contain;
    margin-top: -5px;
    margin-left: 8%;
    padding-top: 3px;
    margin-right: 3px;
    @media screen and (max-width: 750px){
        width: 140px;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
          width: 140px;
    }
`
export const HeaderLogo = styled(HeaderImage)`
    height:50px;
    width: 100%;
    margin-left:${props => (props.isJPNO == "true") ? "15px" : "0"};
    padding-top:0;
    @media screen and (max-width: 750px){
       margin-top:-10px;
    }
`

export const AutoCompleteWrapper= styled.div`
        width: 308px;
        height: 36px;
        border-radius: 5px;
        align-items: center;
        margin-top: ${({station}) => (station ? "unset":"20px")};
        margin-left: auto;
        margin-right: 15px;
        ${props => props.worldHeader && `
            width: 100%;
            margin-top: 10px;
            margin-right: unset;
        `}
        ${props => props.communityHeader && `
        right: 10%;
        `
        }

        ${props => props.give && `
        right: 20%;
        left: auto;
        `
        }
        @media screen and (min-width: 320px) and (max-width: 399px){
            width: 70%;
            margin: 0 auto;
            margin-left: 3%;
            top: ${props=>props.communityHeader?"0px":"0px"};
        }
        @media screen and (min-width: 400px) and (max-width: 480px){
            width: 70%;
            //margin-top: ${props=>props.connect?"5px":"6%"};
            //position: absolute;
            top: ${props=>props.communityHeader?"0px":"0px"};
            //right: ${props=>props.worldHeader? "32%" : "12%"};
            margin: 0 auto;
            margin-left: 4%;
        }
        @media screen and (min-width: 481px) and (max-width: 850px){
            &{
                position: absolute;
                width: 200px;
                // right: ${props=>props.communityHeader?"105px":"80px"};
                top:${props=>props.communityHeader?"0px":"18px"};
                margin-top: 10px;
            }
        } 
       
        @media screen and (min-width: 750px) and (max-width: 1020px) and (orientation: portrait){
            &{
                width: 308px;
                margin-top: 5px;
                position: absolute;
                right: 62px;
            }
        } 
        @media only screen and (min-device-width: 750px) and (max-device-width: 1199px)
            and (orientation: landscape) and and (-webkit-min-device-pixel-ratio: 2){
                &{
                    width: 340px;
                    margin-top: -4px;
                    position: absolute;
                    right: 50px;
                }
        }
        @media screen and (min-width: 1020px) and (max-width: 1200px){
            width: 308px;
        }
        @media screen and (min-width: 1200px) and (max-width:1400px) {
            width: 270px;
        }
`
export const HomeIcon= styled(HeaderNavLinksMbl)`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-top: ${({community}) => (community ? "1px solid #ff6b00":"unset")};  
    padding: ${({community}) => (community ? "10px 0 0 0":"unset")};

    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
    and (orientation: portrait){ 
        border-top: ${({community}) => (community ? "3px solid #ff6b00":"unset")};  
        & img{
            height:30px;
            width:30px;
        }
  }
`;
export const ConnectIconHeader= styled(HeaderNavLinks)`
    position: relative;
    display: ${({isDesktop}) => (isDesktop ? "flex" : "none")}; !important;
    margin-top:${({station}) => (station ? "unset":"20px")};
    margin-right: 15px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    :before{
        background:url(${WhiteConnectIcon}) no-repeat 0 0;
        background-size:contain;
    }
`;
export const MapIconHeader= styled(HeaderNavLinks)`
    position: relative;
    margin-top:${({station}) => (station ? "unset":"20px")};
    display: ${({isDesktop}) => (isDesktop ? "flex" : "none")}; !important;
    margin-right: 15px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    :before{
        content: '';
        display: inline-block;
        width: 28px;
        height: 28px;
        background: url(${WVLogoGlobe}) no-repeat center center;
        background-size: contain;
        vertical-align: middle;
        top: -5%;
        border-radius: 50%;
        box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    }
`;

export const HomeIconHeader= styled(HeaderNavLinks)`
    position: relative;
    display: ${({isDesktop}) => (isDesktop ? "flex" : "none")}; !important;
    margin-top:${({station}) => (station ? "unset":"20px")};
    margin-right: 15px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    :before{
        background:url(${OrangeHomeIcon}) no-repeat 0 0;
        background-size:contain;
    }
`;
export const ConnectIconHeaderMbl= styled(HeaderNavLinksMbl)`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    & img{
        height:18px;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
    and (orientation: portrait){ 
        & img{
            height:30px;
            width:30px;
        }
  }
    
`;
export const HelpIconHeader= styled(HeaderNavLinks)`
    position: relative;
    display: ${({isDesktop}) => (isDesktop ? "flex" : "none")}; !important;
    margin-top: ${({station}) => (station ? "unset":"20px")};
    cursor: pointer;
    padding-left:20px;     
    :before{
        background:url(${getHelpIcon}) no-repeat 0 0;
        background-size:contain;
    }
`;
export const HelpIconHeaderMbl= styled(HeaderNavLinksMbl)`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    ${props => props.give && `
    margin-left: auto;
    `
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
    and (orientation: portrait){ 
        & img{
            height:30px;
            width:30px;
        }
  }
`;
export const HelpIconHomeHeader= styled(HeaderNavLinks)`
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    cursor: pointer;
    padding-left:20px;
    :before{
        background:url(${getHelpIcon}) no-repeat 0 0;
        background-size:contain;
    }

    @media screen and (max-width: 850px){
        &{
            display:none;
        }
`;

export const ConnectText= styled.div`
    color: ${({community}) => (community ? "#FFF":"#111111")};
    font-family: 'Lato-Bold';
    font-size: 17px;
    margin-left: 8px;
    display: inline-block;
    ${props => props.isMap && `
        margin-left: 15px;
    `}
    ${props => props.homeGiveIcon && `
        color: #FFF;
    `}
    @media screen and (max-width: 850px){
        margin-left: unset;
        font-size: 14px;
        padding-top: 5px;
    }
    @media screen and (min-width: 1200px) and (max-width:1400px) {
        {
            margin-left: ${({isMap}) => (isMap ? "15px":"7px")};
        }
    } 
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
        and (orientation: portrait){ 
            font-size: 17px;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
    and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2){ 
        font-size: 13px !important;
    }
    @media only screen and (min-device-width: 992px) and (max-device-width: 1279px){
        font-size: 14px;
    }
`;
export const GetHelpBlueText= styled.div`
    color: rgba(57, 96, 134, 1);
    font-family: 'Lato-Bold';
    font-size: 17px;
    margin-left: 5px;
    display: inline-block;
`;
export const GiveIconImg=styled.img`
        position: relative;
        top: 0px;
`;
export const GiveIconHeader=styled(HeaderNavLinks)`
    margin-top: ${({station}) => (station ? "unset":"0px")};
    display: ${({isDesktop}) => (isDesktop ? "flex" : "none")}; !important;
    padding-left:20px;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    :before{
        background:url(${props => !props.gift ?  Give : `${props.connect ?  GiftIcon : GiftIconOrange}` }) no-repeat 0 0;
        background-size:contain;
    }
`;

export const GiveIconHeaderMbl=styled(HeaderNavLinksMbl)`
    position: relative;
    display: flex;
    flex-direction: column;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
    and (orientation: portrait){ 
        & img{
            height:30px;
            width:30px;
        }
  }
`;

export const GiveText=styled.div`
color: #396086;
font-family: "Lato-Bold";
font-size: 18px;
font-style: normal;
line-height: 120%;
margin-left: 5px;
display: inline-block;
`

export const NewsfeedIconHeader=styled(HeaderNavLinks)`
    position: relative;
    padding-left:20px;
    margin-top: ${({station}) => (station ? "unset":"20px")};
    cursor: pointer;
    color:${props => (props.textcolor) ? "#ffffff" : "#111111"};
    font-family: 'Lato-Bold';
    font-size: 17px;
    margin-right: 15px;
    ${props => (props.page === "station" || props.page ==="childstation" ||  props.page ==="gethelp") && `
        display:inline-block;
        color:rgb(57, 96, 134);
        margin-right: 15px;
    `}
    ${props => props.page === "station" && `
        top:-3px;
    `}
    ${props => props.page === "world" && `
        cursor: pointer;
    `}
    :before{
        background:url(${newsfeed_orange}) no-repeat 0 0;
        background-size:contain;
     }  
    display: ${({isDesktop}) => (isDesktop ? "flex" : "none")}; !important; 
`

export const NewsfeedIconHeaderMlb=styled(HeaderNavLinksMbl)`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #fff;
    font-family: 'Lato-Bold';
    font-size: 17px;  
`

export const HeaderItemsWrapper = styled.div`
//   position:relative;
     display:flex;
     flex-direction:row;
     margin-left:auto;
  @media screen and (max-width: 850px){
    width:unset;
    left: unset;
    height:unset;
  }
  ${props => props.communityStation && `
    left: 68%;
    margin-top: 5px;
    width:25%;
 `}
 ${props => props.connect && `
    left: 47.5%;
    margin-top: 5px;
    width:47%;
    justify-content: flex-end;
 `}
  place-items: center;
  & > :first-child {
    margin-left: auto;
  }
`

export const BackButton = styled.button`{
    position: relative;
    width: auto;
    //height: 18px;
    margin-left: 23px;
    //margin-top: 27px;
    padding-left:12px;
    background-color: transparent;
    z-index:5;

    ${props => props.registerBack && `
        margin-left: unset;
        top: 0px;
        margin-bottom: 20px;
     `}

    & span{
        position: relative;
        font-family: 'Lato';
        font-style: normal;
        font-weight: 400;
        font-size: 15px;
        line-height: 115%;
        text-align: center;
        letter-spacing: 0.01em;
        color: #111111;
    }
    : before{
        content:"";
        height:12px;
        width:12px;
        position:absolute;
        left:0px;
        top:6px;
        background:url(${BackbuttonIcon}) no-repeat 0 0;
        background-size:contain;
    }
    @media screen and (max-width: 850px){
        margin-left: 5px;
        margin-top: 0px;
    }
}`

export const DeleteAccountButton = styled.div`
    display:flex;
    flex-flow:column;
    align-items: center;
    justify-content: center;
`
export const SubmitRequestButton = styled.div`
    padding: 0.75rem 1.5rem;
    background-color: rgb(255, 107, 0);
    box-shadow: rgb(199, 83, 0) 0px 3px 0px;
    color: rgb(255, 255, 255);
    border-radius: 8px;
    text-align: center;
    font-size: 18px;
    font-family: Lato;
    cursor: pointer;
    margin: 6px 6px 1.5%;
    @media screen and (max-width: 750px){
        margin-bottom: 5%;
    }
`
export const ContactUsButton = styled.div`
    padding: 0.75rem 1.5rem;
    color: rgba(199, 83, 0, 1);
    text-align: center;
    font-size: 15px;
    font-family: Lato;
    font-weight:700;
    cursor: pointer;
    text-decoration: underline;
`

export const StationModalHeader = styled.div`
    display: flex !important;
    width: 100%;
    padding:0 1% 0 0;
    height: 80px;
    align-items: center;
    position: fixed;
    top: 0;
    width: 100%;
    background-color: #fff;
    z-index:11;
    // background: url(${StationsModalBg}) 0 0;
    @media screen and (max-width: 750px){
        padding:0 2%;
        position: fixed;
        background: #FFF;
        height: 60px;
    }
`
export const CloseIcon = styled.span`
    color: #FFF;
    cursor: pointer;
`